import React, { useRef } from 'react';

import { AlertDialog, Button } from '@rbilabs/universal-components';

import { ErrorText } from 'components/checkout-errors-modal/checkout-error-cell/styled';
import { StyledHeader } from 'components/checkout-errors-modal/styled';
import { AlertDialogEventLogger } from 'components/dialog/alert-dialog-event-logger';
import { t } from 'state/intl/translations';
import { useUIContext } from 'state/ui';

import {
  CartAnalyticsModalActionNames,
  CartAnalyticsModalNames,
  logCartModalAction,
} from '../../utils/cart-analytics';

type CartDeliveryMinimumSubtotalModalProps = {
  isOpen: boolean;
  onClose: () => void;
  minimumSubtotalCents?: number;
};

export const CartDeliveryMinimumSubtotalModal = ({
  isOpen,
  onClose,
  minimumSubtotalCents = 500,
}: CartDeliveryMinimumSubtotalModalProps) => {
  const cancelRef = useRef(null);
  const { formatCurrencyForLocale } = useUIContext();
  const minimumSubtotalText = formatCurrencyForLocale(minimumSubtotalCents);
  const headerText = t('deliveryFeesStripeTitleSuffix', { amount: minimumSubtotalText });
  const messageText = t('deliveryMinumumNotReached', { min: minimumSubtotalText });

  if (!isOpen) {
    return null;
  }

  return (
    <AlertDialogEventLogger
      testID="cart-delivery-minimum-subtotal-dialog"
      modalAppearanceEventMessage="Delivery minimum subtotal"
      modalAppearanceHeader={headerText}
      modalAppearanceMessage={messageText}
      isErrorModal
      leastDestructiveRef={cancelRef}
      isOpen={isOpen}
      onClose={onClose}
      closeOnOverlayClick={false}
    >
      <AlertDialog.Content>
        <AlertDialog.Header>
          <StyledHeader variant="headerTwo">{headerText}</StyledHeader>
        </AlertDialog.Header>
        <AlertDialog.Body>
          <ErrorText>{messageText}</ErrorText>
        </AlertDialog.Body>
        <AlertDialog.Footer>
          <Button
            width="full"
            onPress={() => {
              logCartModalAction({
                actionName: CartAnalyticsModalActionNames.OKAY,
                modalName: CartAnalyticsModalNames.DELIVERY_MINIMUM_SUBTOTAL,
              });
              onClose();
            }}
            testID="cart-delivery-minimum-subtotal-ok"
          >
            {t('okay')}
          </Button>
        </AlertDialog.Footer>
      </AlertDialog.Content>
    </AlertDialogEventLogger>
  );
};
